export const updatePanelVersion = version => {
    localStorage.setItem('version', version);
    window.location.reload(true);
};